import { get } from 'lodash';
import React, { FC } from 'react';
import SummaryLine from 'src/components/ui-component/form-component/abschluss-page/SummaryLine';
import { useApplication } from 'src/context/ApplicationContext';
import { NACHWEIS_POSITION_STATUS, PROJEKTDURCHFUERUNG } from 'src/lib/constants/constant';
import MittelabrufSchema from 'src/lib/paths/mittelabruf_FULL_Paths.json';
import NachweisPositionSchema from 'src/lib/paths/nachweisposition_FULL_Paths.json';
import { DisplayDateTime, DisplayEuroMUI } from 'src/utils/formats';
import AbschlussSeiteBox from '../../../../antrag-components/AbschlussSeiteBox';
const MA_P = MittelabrufSchema.attributes;
const NP_P = NachweisPositionSchema.attributes;

const AbschlussMaEpz: FC<{}> = () => {
	const { application } = useApplication();
	const nachweispositionen = get(application, MA_P.Mittelabruf_Nachweispositions.path, []);
	const getNachweispositionByStatus = (status: string) => {
		return (nachweispositionen as any[]).find((eachPosition: any) => get(eachPosition, NP_P.Allgemein_Status.path) === status);
	};
	const projektausgabenAngefallen = Number(
		get(getNachweispositionByStatus(NACHWEIS_POSITION_STATUS.bereitsAngefalleneAusgaben), NP_P.Allgemein_Ausgaben_Kosten.path, 0),
	);
	const projektausgabenGeplant = Number(get(getNachweispositionByStatus(NACHWEIS_POSITION_STATUS.geplant), NP_P.Allgemein_Ausgaben_Kosten.path, 0));
	const anzahlMonate =
		(
			get(
				application,
				MA_P.Foerderantrag.schema.attributes.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Projektdurchfuehrung.path,
				'',
			) === PROJEKTDURCHFUERUNG.inland
		) ?
			'drei'
		:	'sechs';
	return (
		<>
			<AbschlussSeiteBox>
				<SummaryLine
					label='Datum der Einreichung'
					value={
						get(application, MA_P.Allgemein_Eingereicht_Am.path) ?
							DisplayDateTime(get(application, MA_P.Allgemein_Eingereicht_Am.path))
						:	'noch nicht eingereicht'
					}
				/>
				<SummaryLine label='Projekttitel' value={get(application, MA_P.Foerderantrag.schema.attributes.Allgemein_Projekttitel.path, '')} />
				<SummaryLine label='Projektausgaben' value={''} />
				<SummaryLine
					label='bis jetzt angefallene Projektausgaben'
					value={DisplayEuroMUI(projektausgabenAngefallen)}
					labelPadding={'0.75rem 0 0.75rem 2rem'}
				/>
				<SummaryLine
					label={`in den nächsten ${anzahlMonate} Monaten anfallende Projektausgaben`}
					value={DisplayEuroMUI(projektausgabenGeplant)}
					labelPadding={'0.75rem 0 0.75rem 2rem'}
				/>
				<SummaryLine
					label={'Mittelabruf'}
					value={DisplayEuroMUI(get(application, MA_P.Ermittlung_Des_Auszahlungsbetrages_Anforderungsbetrag.path, 0))}
				/>
			</AbschlussSeiteBox>
		</>
	);
};

export default AbschlussMaEpz;
